import type { ConfigType } from '@plone/registry';
import installSettings from './config/settings';

// Slider
import SliderEdit from './my-blocks/custom-slider-no-link/components/Edit';
import SliderView from './my-blocks/custom-slider-no-link/components/View';
import { SliderBlockDataAdapter } from './my-blocks/custom-slider-no-link/components/adapter';
import sliderSVG from '@plone/volto/icons/slider.svg';
import './my-blocks/custom-slider-no-link/theme/main.less';

/* import './theme/_variables.scss';
 */

import { ProjektTemplate } from './customizations/volto/components/manage/Blocks/Listing';
import { AktuellesTemplate } from './customizations/volto/components/manage/Blocks/Listing';
import { VeranstaltungsTemplate } from './customizations/volto/components/manage/Blocks/Listing';
import { ProjektNewsTemplate } from './customizations/volto/components/manage/Blocks/Listing';
import { ProjektView } from './customizations/volto/components/theme/View';
import { ProjektPageView } from './customizations/volto/components/theme/View';
import { ProjektNewsView } from './customizations/volto/components/theme/View';

import './theme/typography.css';
import './theme/_main.scss';

function applyConfig(config: ConfigType) {
  installSettings(config);

  config.views = {
    ...config.views,
    contentTypesViews: {
      ...config.views.contentTypesViews,
      projekt: ProjektView,
      projektpage: ProjektPageView,
      projektnews: ProjektNewsView,
    },
  };

  // Slider
  config.blocks.blocksConfig.slider = {
    id: 'slider',
    title: 'SliderNoLink',
    group: 'common',
    icon: sliderSVG,
    view: SliderView,
    edit: SliderEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    referenceContainerQuery: '.container .header',
    dataAdapter: SliderBlockDataAdapter,
  };

  config.blocks.blocksConfig.listing.variations = [
    ...config.blocks.blocksConfig.listing.variations,
    {
      id: 'ProjektTemplate',
      title: 'Projekte',
      template: ProjektTemplate,
    },
    {
      id: 'AktuellesTemplate',
      title: 'Aktuelles',
      template: AktuellesTemplate,
      fullobjects: true,
    },
    {
      id: 'VeranstaltungsTemplate',
      title: 'Veranstaltung',
      template: VeranstaltungsTemplate,
      fullobjects: true,
    },
    {
      id: 'ProjektNewsTemplate',
      title: 'ProjektNews',
      template: ProjektNewsTemplate,
      fullobjects: true,
    },
  ];
  return config;
}

export default applyConfig;
